import { BrowserRouter, Routes, Route } from 'react-router-dom'
import PublicLayout from './layout/PublicLayout'
import AppLayout from './layout/AppLayout'
import RequireAuth from './components/RequireAuth'
import RequireProfile from './components/RequireProfile'
import LandingPage from './pages/LandingPage'
import LoginPage from './pages/LoginPage'
import SignupPage from './pages/SignupPage'
import OnboardingPage from './pages/OnboardingPage'
import HomePage from './pages/HomePage'
import CodePage from './pages/CodePage'
import SearchRoomPage from './pages/SearchRoomPage'
import GlobalSearchPage from './pages/GlobalSearchPage'
import GlobalTextSearchPage from './pages/GlobalTextSearchPage'
import NotebooksPage from './pages/NotebooksPage'
import GuidesPage from './pages/GuidesPage'
import ChatPage from './pages/ChatPage'
import PlaceholderPage from './pages/PlaceholderPage'
import TopicsPage from './pages/TopicsPage'
import NetworkPage from './pages/NetworkPage'
import NotFoundPage from './pages/NotFoundPage'
import DocumentTitle from './components/DocumentTitle'

function App() {
  return (
    <BrowserRouter>
      <DocumentTitle>
        <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
        </Route>
        <Route element={<RequireAuth />}>
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route element={<RequireProfile />}>
            <Route element={<AppLayout />}>
              <Route path="/home" element={<HomePage />} />
              <Route
                path="/projects"
                element={<PlaceholderPage title="Projects" storageId="projects-layout" />}
              />
              <Route path="/code" element={<CodePage />} />
              <Route path="/searchrooms" element={<SearchRoomPage />} />
              <Route path="/global-ai-search" element={<GlobalSearchPage />} />
              <Route path="/global-text-search" element={<GlobalTextSearchPage />} />
              <Route path="/notebooks" element={<NotebooksPage />} />
              <Route path="/guides" element={<GuidesPage />} />
              <Route path="/topics" element={<TopicsPage />} />
              <Route path="/chat" element={<ChatPage />} />
              <Route path="/network" element={<NetworkPage />} />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </DocumentTitle>
    </BrowserRouter>
  )
}

export default App
